import React from 'react';

export const MarketingContext = React.createContext();
MarketingContext.displayName = 'MarketingContext';
